import { render, staticRenderFns } from "./CEFoundationMenu.vue?vue&type=template&id=138f6246&"
import script from "./CEFoundationMenu.vue?vue&type=script&lang=ts&"
export * from "./CEFoundationMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports